export const getFlag = (countryCode) => {
    return `https://catamphetamine.gitlab.io/country-flag-icons/3x2/${countryCode || "US"}.svg`;
};
